function encode(data) {
  const formData = new FormData();

  Object.keys(data).forEach((key) =>
    formData.append(key, data[key])
  );

  return formData;
}

const submitForm = async (formName, formValues) => {
  try {
    const response = await fetch('/', {
      method: 'POST',
      body: encode({
        'form-name': formName,
        ...formValues,
      }),
    });
    if (response.ok) {
      return Promise.resolve(response.statusText);
    } else {
      return Promise.reject(response.statusText);
    }
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};

export default submitForm;
